import { supabase } from "../Supabase";

const n = (v, def = 0) => (Number.isFinite(Number(v)) ? Number(v) : def);

export async function getJobsForUser() {
  const { data: userData } = await supabase.auth.getUser();
  if (!userData?.user) throw new Error("Not authenticated");

  const { data, error } = await supabase
    .from("jobs")
    .select(
      `
      id,
      name,
      description,
      billing_type,
      flat_price,
      job_items (
        id,
        description,
        qty,
        unit_price
      )
    `
    )
    .eq("user_id", userData.user.id)
    .order("created_at", { ascending: false });

  if (error) throw error;

  return (data ?? []).map((row) => ({
    id: row.id,
    name: row.name,
    description: row.description,
    billingType: row.billing_type,
    flatPrice: row.flat_price ?? null,
    items: (row.job_items ?? []).map((it) => ({
      id: it.id,
      description: it.description,
      qty: n(it.qty, 1),
      unitPrice: n(it.unit_price, 0),
    })),
  }));
}

export async function createJob(input) {
  const { data: userData } = await supabase.auth.getUser();
  if (!userData?.user) throw new Error("Not authenticated");

  const { data: jobRow, error: jobErr } = await supabase
    .from("jobs")
    .insert({
      user_id: userData.user.id,
      name: input.name,
      description: input.description ?? null,
      billing_type: input.billingType,
      flat_price: input.billingType === "flat" ? input.flatPrice ?? 0 : null,
    })
    .select("id, name, description, billing_type, flat_price")
    .single();

  if (jobErr) throw jobErr;

  if (input.billingType === "items" && input.items.length) {
    const { error: itemsErr } = await supabase.from("job_items").insert(
      input.items.map((it) => ({
        job_id: jobRow.id,
        description: it.description,
        qty: it.qty,
        unit_price: it.unitPrice,
      }))
    );
    if (itemsErr) throw itemsErr;
  }

  const [job] = await getJobsForUser();
  return job;
}

export async function updateJob(input) {
  const { data: userData } = await supabase.auth.getUser();
  if (!userData?.user) throw new Error("Not authenticated");

  const { error: jobErr } = await supabase
    .from("jobs")
    .update({
      name: input.name,
      description: input.description ?? null,
      billing_type: input.billingType,
      flat_price: input.billingType === "flat" ? input.flatPrice ?? 0 : null,
    })
    .eq("id", input.id)
    .eq("user_id", userData.user.id);

  if (jobErr) throw jobErr;

  const { error: delErr } = await supabase
    .from("job_items")
    .delete()
    .eq("job_id", input.id);
  if (delErr) throw delErr;

  if (input.billingType === "items" && input.items.length) {
    const { error: insErr } = await supabase.from("job_items").insert(
      input.items.map((it) => ({
        job_id: input.id,
        description: it.description,
        qty: it.qty,
        unit_price: it.unitPrice,
      }))
    );
    if (insErr) throw insErr;
  }
}
